export default __webpack_public_path__ + "static/media/warning--dangerous-crosswinds-left--g2.c8bf2f3a.png";